import React, { lazy, Suspense } from "react";
import SpinnerComponent from "./shared/spinner";
import { Routes, Route } from "react-router-dom";
import PrivateRoute from "./config/auth";
import Admin from "./pages/login-pages/admin";
import Login from "./pages/login-pages/login";
import Register from "./pages/login-pages/register";
import Home from "./pages/login-pages/home";
import ForgotPSW from "./pages/login-pages/forgotPsw";
import NewPassword from "./pages/login-pages/new-password";
import Operators from "./pages/Operators";

const LazyAdminOperators = lazy(
  () => import("./pages/admin-operators-decoblock/index"),
);

const LazyNewConteoInventory = lazy(
  () => import("./pages/inventory/inventory-selected/new-count/index"),
);

const LazyQaCertificates = lazy(() => import("./pages/qa-certificates/index"));

const LazyArmaduras = lazy(() => import("./pages/armaduras/index"));

const LazyDispatchReferrals = lazy(
  () => import("./pages/dispatchReferrals/index"),
);

const LazyTrackingPage = lazy(() => import("./pages/tracking/tracking"));

const LazySelectedInventory = lazy(
  () => import("./pages/inventory/inventory-selected/index"),
);

/* const LazyCountPage = lazy(() =>
  import("./pages/inventory/inventory-selected/count/index")
); */

const LazyInventory = lazy(() => import("./pages/inventory/index"));

const LazyInvetoryRegister = lazy(
  () => import("./pages/inventory-register/index"),
);

const LazyTracking = lazy(() => import("./pages/tracking/index"));

const LazyTaxWithholding = lazy(() => import("./pages/tax-withholding/index"));

const LazyDispatchFormatIndex = lazy(
  () => import("./pages/formato-despachos/index"),
);

const LazyBudgetSystem = lazy(() => import("./pages/budget-system/index"));

const LazySstControl = lazy(() => import("./pages/sst-control/index"));

const LazySstDocsProviders = lazy(
  () => import("./pages/sst-docs-providers/index"),
);

const LazyShiftProgram = lazy(
  () => import("./pages/shift-program-pages/index"),
);

const LazyInitCxT = lazy(
  () => import("./pages/consulta-x-terceros-pages/init-cxt"),
);

const LazyInitSkakoPortal = lazy(
  () => import("./pages/skako-pages/init-skako-portal"),
);

const LazyDocs = lazy(() => import("./pages/Docs/init-page"));

const LazySapAmInitPortal = lazy(
  () => import("./pages/am-pages/sap-am-init-portal"),
);

const LazyAdminPermissions = lazy(
  () => import("./pages/admin-pages/admin-permission"),
);

const LazyMasterRawMaterial = lazy(
  () => import("./pages/recipes-pages/master-raw-material"),
);

const LazyInitRecipesPortal = lazy(
  () => import("./pages/recipes-pages/init-recipes-portal"),
);

const LazyInitBiometricPortal = lazy(
  () => import("./pages/biometric-decoblock/init-biometric-portal"),
);

const LazyInitBudget = lazy(() => import("./pages/budget-pages/init-budget"));

const LazyInboxPurchase = lazy(
  () => import("./pages/purchase-order-approval-pages/inbox-purchase"),
);

const LazyInitShiftDelivery = lazy(
  () => import("./pages/shift-delivery-pages/init-shift-delivery"),
);

const LazyApproverPage = lazy(
  () => import("./pages/purchase-order-approval-pages/approver-page"),
);

const LazyInitPurchasePortal = lazy(
  () => import("./pages/purchase-order-approval-pages/init-purchase-portal"),
);

const LazyRequestTechnical = lazy(
  () => import("./pages/technical-data-sheets/init-request-management-tech"),
);
const LazyPermissions = lazy(() => import("./pages/admin-pages/permissions"));

const LazyTest = lazy(() => import("./pages/test/test.desarrollo"));

const LazyProductionReport = lazy(
  () => import("./pages/produccion-pages/init-production-report"),
);

const LazyRepProductionForm = lazy(
  () => import("./pages/produccion-pages/report-production"),
);

const LazyEditProductionReport = lazy(
  () => import("./pages/produccion-pages/edit-report-production"),
);

const LazyAddOperators = lazy(
  () => import("./pages/admin-pages/add-operators"),
);

const LazyFormsPage = lazy(() => import("./pages/form-pages/form-home"));

const LazyConsolidationDowntime = lazy(
  () => import("./pages/assist-production-pages/consolidation-downtime"),
);

const LazyInitProductionReportDecoblock = lazy(
  () =>
    import("./pages/production-decoblock-pages/init-production-report-decoblock"),
);

const LazyConsolidationTitanProdReport = lazy(
  () => import("./pages/produccion-pages/consolidado-reppro-titan"),
);

const LazyMonthlyProduction = lazy(
  () => import("./pages/assist-production-pages/monthly-production-titan"),
);

const LazySheetsCommercialAdmin = lazy(
  () => import("./pages/technical-data-sheets/commercial-admin"),
);

const LazyImpresion = lazy(() => import("./pages/test/impresion"));

const LazyAccionistasLinkDownload = lazy(
  () => import("./pages/test/accionistas-link-download"),
);

const LazyAccionistasDocs = lazy(() => import("./pages/test/accionistas-doc"));

const LazyAdminReferencesArmatures = lazy(
  () => import("./pages/armatures-pages/admin-references-armatures"),
);

const LazyFinderArmatures = lazy(
  () => import("./pages/armatures-pages/finder-armatures"),
);

const LazyInitArmatures = lazy(
  () => import("./pages/armatures-pages/init-armatures"),
);

const LazyInitPortalTechSheets = lazy(
  () => import("./pages/technical-data-sheets/tech-sheet-init-portal"),
);

const LazyProductionReportFormDecoblock = lazy(
  () =>
    import("./pages/production-decoblock-pages/report-production-decoblock"),
);

const LazyConsolidationReportDecoblock = lazy(
  () =>
    import("./pages/production-decoblock-pages/consolidation-report-decoblock"),
);

const LazyConsolidationDowntimeDecoblock = lazy(
  () =>
    import("./pages/production-decoblock-pages/downtime-consolidation-decoblock"),
);

const LazyProductionReportFormDecoblockSoledad = lazy(
  () =>
    import("./pages/soledad-production-decoblock/sl-report-production-decoblock"),
);

const LazyProductionReportFormTitanGirardota = lazy(
  () =>
    import("./pages/girardota-production-titan/girardota-report-production-titan"),
);

const LazyProductionReportFormTitanSoledad = lazy(
  () =>
    import("./pages/soledad-production-titan/soledad-report-production-titan"),
);

const LazyProductionReportTitanGirardota = lazy(
  () =>
    import("./pages/girardota-production-titan/init-production-report-titan-girardota"),
);

const LazyProductionReportTitanSoledad = lazy(
  () =>
    import("./pages/soledad-production-titan/init-production-report-titan-soledad"),
);

const LazyProductionReportDecoblockSoledad = lazy(
  () =>
    import("./pages/soledad-production-decoblock/init-production-report-decoblock-soledad"),
);

const LazyConsolidationReportTitanGirardota = lazy(
  () =>
    import("./pages/girardota-production-titan/consolidation-report-titan-girardota"),
);

const LazyConsolidationReportTitanSoledad = lazy(
  () =>
    import("./pages/soledad-production-titan/consolidation-report-titan-soledad"),
);

const LazyConsolidationReportDecoblockSoledad = lazy(
  () =>
    import("./pages/soledad-production-decoblock/consolidation-report-decoblock-soledad"),
);

const LazyConsolidationDowntimeDecoblockSoledad = lazy(
  () =>
    import("./pages/soledad-production-decoblock/downtime-consolidation-decoblock-soledad"),
);

const LazyConsolidationDowntimeTitanGirardota = lazy(
  () =>
    import("./pages/girardota-production-titan/downtime-consolidation-titan-girardota"),
);

const LazyConsolidationDowntimeTitanSoledad = lazy(
  () =>
    import("./pages/soledad-production-titan/downtime-consolidation-titan-soledad"),
);

const LazyFinderRepProduction = lazy(
  () => import("./pages/assist-production-pages/finder-rep-productions"),
);

const LazyConsolidationQaReport = lazy(
  () => import("./pages/qa-pages/consolidation-qa-report"),
);

const LazyReturnsInitPortalTitan = lazy(
  () => import("./pages/returns-titan-pages/returns-init-portal"),
);

const LazyDestajosTitan = lazy(
  () => import("./pages/destajos-pages/destajos-titan"),
);

const LazyChartsReturns = lazy(
  () => import("./pages/returns-titan-pages/chart-returns"),
);

const LazyNonConformityPatio = lazy(
  () => import("./pages/nc-patio-pages/init-nc-patio"),
);

const LazyReturnsConsolidation = lazy(
  () => import("./pages/returns-titan-pages/returns-consolidation"),
);

const LazyGeneralTechSheet = lazy(
  () => import("./pages/technical-data-sheets/general-tech-sheet"),
);

const LazyIdentification = lazy(
  () => import("./pages/identification-service/frame"),
);

const LazyMasterOfSheets = lazy(
  () => import("./pages/technical-data-sheets/master-of-sheets"),
);

export default function RoutesApp({ isAuth, setIsAuth, token }) {
  return (
    <Routes>
      <Route path="/" element={<Home setIsAuth={setIsAuth} />} />
      <Route path="/home" element={<Home setIsAuth={setIsAuth} />} />
      {/* Rutas Administrativas */}
      <Route
        path="/admin"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Admin />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/reportesdeproduccion"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyProductionReport token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/reportesdeproduccion/reportedeproduccion"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyRepProductionForm token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/editproductionreport/:id"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyEditProductionReport token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/permiss"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyPermissions token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Administrador de Operarios */}
      <Route
        path="/admin/administradordeoperarios"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Operators />
          </PrivateRoute>
        }
      />

      {/* Rutas de producción titan cota */}
      <Route
        path="/admin/consolidadorepproducciontitan"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyConsolidationTitanProdReport token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/agregaroperarios"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyAddOperators token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/formularios"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyFormsPage token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/consolidadotiemposmuertos"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyConsolidationDowntime token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/busquedareportesdeproducciontt"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyFinderRepProduction />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/produccionmensualtitan"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyMonthlyProduction token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Rutas de producción de Titan Girardota */}
      <Route
        path="/admin/consolidadoproducciontitangirardota"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyConsolidationReportTitanGirardota token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/reportesdeproducciontitangirardota"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyProductionReportTitanGirardota token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/reportesdeproducciontitangirardota/forms"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyProductionReportFormTitanGirardota token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/tiemposmuertostitangirardota"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyConsolidationDowntimeTitanGirardota token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Rutas de producción de Titan Soledad */}
      <Route
        path="/admin/consolidadoproducciontitansoledad"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyConsolidationReportTitanSoledad token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/reportesdeproducciontitansoledad"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyProductionReportTitanSoledad token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/reportesdeproducciontitansoledad/forms"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyProductionReportFormTitanSoledad token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/tiemposmuertostitansoledad"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyConsolidationDowntimeTitanSoledad token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Rutas de produccion decoblock cota */}
      <Route
        path="/admin/reportesdeproducciondecoblock"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyInitProductionReportDecoblock token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/reportesdeproducciondecoblock/repprodecoblock"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyProductionReportFormDecoblock token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/consolidadorepproducciondecoblock"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyConsolidationReportDecoblock token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/tiemposmuertosdecoblock"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyConsolidationDowntimeDecoblock token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Rutas Decoblock Soledad */}
      <Route
        path="/admin/consolidadoproducciondecoblocksoledad"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyConsolidationReportDecoblockSoledad token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/reportesdeproducciondecoblocksoledad"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyProductionReportDecoblockSoledad token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/reportesdeproducciondecoblocksoledad/forms"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyProductionReportFormDecoblockSoledad token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/tiemposmuertosdecoblocksoledad"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyConsolidationDowntimeDecoblockSoledad token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />

      {/* Rutas de QA titan */}
      <Route
        path="/admin/consolidadonctitan"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyConsolidationQaReport token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />

      {/* Rutas de despachos */}
      <Route
        path="/admin/portaldevolucionestitan"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyReturnsInitPortalTitan token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />

      {/* Rutas de destajos */}
      <Route
        path="/admin/gestiondedestajos"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyDestajosTitan token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Rutas de Devolvuiones */}
      <Route
        path="/admin/consolidadodevoluciones/:id"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyReturnsConsolidation token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/graficasdedevoluciones"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyChartsReturns token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Rutas de No conformes patio */}
      <Route
        path="/admin/noconformespatio"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyNonConformityPatio token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Rutas del portal de fichas tecnicas */}
      <Route
        path="/admin/portalfichastecnicas"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyInitPortalTechSheets token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/portalfichastecnicas/fichas"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyGeneralTechSheet token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/maestrodefichas"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyMasterOfSheets token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Mismas rutas diferente nombre en menú */}
      <Route
        path="/admin/portalcomerciales"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazySheetsCommercialAdmin token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/solicitudesoficinatecnica"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazySheetsCommercialAdmin token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/portalfichascomerciales"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazySheetsCommercialAdmin token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Fin mismas rutas */}
      <Route
        path="/admin/solicitudesgerenciatecnica"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyRequestTechnical token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Ruta de tester */}
      <Route
        path="/admin/pruebas"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyTest />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Rutas de Armaduras */}
      <Route
        path="/admin/registrodearmaduras"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyInitArmatures token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/busquedadearmaduras"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyFinderArmatures token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/admindearmaduras"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyAdminReferencesArmatures token={token} />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/sistemaidentificacion"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyIdentification />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Rutas de aprobaciones de ordenes de compra */}
      <Route
        path="/admin/portaldeaprobaciones"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyInitPurchasePortal />
            </Suspense>
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/portaldeaprobaciones/approver/:id"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyApproverPage />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/solicitudesdecompras"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyInboxPurchase />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Rutas de Presupuestos */}
      <Route
        path="/admin/portalpresupuestos"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyInitBudget />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/sistemadepresupuestos"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyBudgetSystem />
            </Suspense>
          </PrivateRoute>
        }
      />

      {/* Rutas de entregas de turno */}
      <Route
        path="/admin/entregadeturnos"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyInitShiftDelivery />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Rutas de Biometrico decoblock */}
      <Route
        path="/admin/biometricodecoblock"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyInitBiometricPortal />
            </Suspense>
          </PrivateRoute>
        }
      />

      {/* Recetas Nuevass */}
      <Route
        path="/admin/portalderecetas"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyInitRecipesPortal />
            </Suspense>
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/maestromateriasprimas"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyMasterRawMaterial />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Rutas de accionistas */}
      <Route
        path="/3qar2mttdck23utcadkmt0"
        element={
          <Suspense fallback={<SpinnerComponent />}>
            <LazyAccionistasDocs />
          </Suspense>
        }
      />
      <Route
        path="/k3ytddwllc0xgwy"
        element={
          <Suspense fallback={<SpinnerComponent />}>
            <LazyAccionistasLinkDownload />
          </Suspense>
        }
      />
      <Route
        path="/jncsdbhashiw6780n"
        element={
          <Suspense fallback={<div>...Loading...</div>}>
            <LazyImpresion />
          </Suspense>
        }
      />
      {/* Rutas SST */}
      <Route
        path="/admin/sstcontrolparafiscales"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazySstDocsProviders />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/sstcontrolingresos"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazySstControl />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Ruta de tracking */}
      <Route
        path="/admin/sincronizarsap-tracking"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyTracking />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/rutastracking"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyTrackingPage />
            </Suspense>
          </PrivateRoute>
        }
      />

      {/* Rutas de Adminstrador de permisos */}
      <Route
        path="/admin/administradordepermisos"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyAdminPermissions />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/documentacionaplicativos"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyDocs />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Rutas de Skako */}
      <Route
        path="/admin/portalskako"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyInitSkakoPortal />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Rutas de Cuntas x terceros */}
      <Route
        path="/admin/consultaxterceros"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyInitCxT />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Rutas para programación de turnos */}
      <Route
        path="/admin/programaciondeturnos"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyShiftProgram />
            </Suspense>
          </PrivateRoute>
        }
      />
      {/* Rutas de formato de despachos */}
      <Route
        path="/admin/formatodedespachos"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyDispatchFormatIndex />
            </Suspense>
          </PrivateRoute>
        }
      />

      {/* Rutas para armaduras */}
      <Route
        path="/admin/portalarmaduras"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyArmaduras />
            </Suspense>
          </PrivateRoute>
        }
      />

      {/* Rutas de Invetarios*/}
      <Route
        path="/admin/registrodeinventarios"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyInvetoryRegister />
            </Suspense>
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/registrodeinventario"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyInventory />
            </Suspense>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/inventory/:id"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazySelectedInventory />
            </Suspense>
          </PrivateRoute>
        }
      />

      <Route
        path="/admin/conteodeinventario"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              {/*  <LazyCountPage /> */}
              <LazyNewConteoInventory />
            </Suspense>
          </PrivateRoute>
        }
      />

      {/* Ruta administrador de operarios decoblock */}
      <Route
        path="/admin/adminoperariosdecoblock"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              {/*  <LazyCountPage /> */}
              <LazyAdminOperators />
            </Suspense>
          </PrivateRoute>
        }
      />

      {/*  Rutas de Certificados de impuestos */}
      <Route
        path="/admin/certificadosdeimpuestos"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyTaxWithholding />
            </Suspense>
          </PrivateRoute>
        }
      />

      {/* Rutas de Remisiones de despachos */}
      <Route
        path="/admin/remisionesdedespachos"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<div>Loading...</div>}>
              <LazyDispatchReferrals />
            </Suspense>
          </PrivateRoute>
        }
      />

      {/* Rutas para certificados de calidad */}
      <Route
        path="/admin/certificadosdecalidad"
        element={
          <PrivateRoute isAuth={isAuth}>
            <Suspense fallback={<SpinnerComponent />}>
              <LazyQaCertificates />
            </Suspense>
          </PrivateRoute>
        }
      />

      {/* rutas de login y registro */}
      <Route
        path="/login"
        element={<Login titulo={"Titan login"} setIsAuth={setIsAuth} />}
      />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-pws" element={<ForgotPSW />} />
      <Route
        path="/new-password"
        component={NewPassword}
        element={<NewPassword />}
      />

      {/* Ruta AM */}
      <Route
        path="/sap-am"
        element={
          <Suspense fallback={<SpinnerComponent />}>
            <LazySapAmInitPortal />
          </Suspense>
        }
      />
    </Routes>
  );
}
